import { getClosestConfigurationFromRectangleTable } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import { SPACING_HORIZONTAL } from '%paysera_seat_selection/js/seatSelection/config/defaults';

function mergeLabel(table, compiledLabel) {
    table.label = {
        ...table.label,
        compiled: {
            ...compiledLabel,
        },
        transformation: {
            rotation: -table.transformation.rotation,
        },
    };

    return table;
}

function compileRectangleTableLabel(table) {
    const configuration = getClosestConfigurationFromRectangleTable(table, 'fontConfig');
    const { spacing } = getClosestConfigurationFromRectangleTable(table, 'spacing');
    const { seatConfig } = getClosestConfigurationFromRectangleTable(table, 'seatConfig');

    const {
        label: { text, manual },
        compiled: { width },
    } = table;

    if (text === null) {
        return table;
    }
    const compiledLabel = {
        ...table.label.compiled,
        size: configuration.fontConfig.size.rectangleTable,
        family: configuration.fontConfig.family,
        color: configuration.fontConfig.color,
    };

    if (manual) {
        return mergeLabel(table, compiledLabel);
    }

    let labelSpacing = spacing.h;
    if (table.seatsNorth > 0) {
        labelSpacing = seatConfig.size + spacing.h + SPACING_HORIZONTAL;
    }

    compiledLabel.x = width / 2;
    compiledLabel.y = -labelSpacing;
    compiledLabel.text = { ...compiledLabel.text, x: compiledLabel.x, y: compiledLabel.y };

    return mergeLabel(table, compiledLabel);
}

export default compileRectangleTableLabel;
